import { LiveChat } from '@bolddesk/live-chat-web-sdk'
import { LocaleEnum } from '@systemeio/ui'
import { useEffect } from 'react'

interface BoldDeskProps {
  shouldRender: boolean
  locale: LocaleEnum
}

export function BoldDesk({ shouldRender, locale }: BoldDeskProps) {
  useEffect(() => {
    if (shouldRender) {
      LiveChat.configure('cfb6c538-17e0-4aea-b782-33ff907747c3', 'https://systemeio.bolddesk.com', {
        locale,
      })
      LiveChat.showWidget()
    } else {
      LiveChat.hideWidget()
    }
  }, [shouldRender, locale])

  return null
}
